import { render, staticRenderFns } from "./ApprenticeshipTypesFilter.vue?vue&type=template&id=31bc0ce4&scoped=true&"
import script from "./ApprenticeshipTypesFilter.vue?vue&type=script&lang=js&"
export * from "./ApprenticeshipTypesFilter.vue?vue&type=script&lang=js&"
import style0 from "./ApprenticeshipTypesFilter.vue?vue&type=style&index=0&id=31bc0ce4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bc0ce4",
  null
  
)

export default component.exports